import type { CompareValueRenderer } from '~/components/common/enrichment-compare-grid/compare-cell';

import { EnrichedFieldCell } from './enriched-field-cell';

/**
 * Renders one compare-grid value using the same field renderers as the preview
 * tables, so both presentations show identical content for a given field. Passed
 * to `EnrichmentCompareGrid` as its `renderValue`, keeping the common grid free
 * of enrichment-specific renderers.
 */
export const renderCompareValue: CompareValueRenderer = (key, value, status) => (
  <EnrichedFieldCell
    testId={`compare-value-${key}`}
    fieldName={key}
    value={value}
    dense
    {...(status !== undefined && { status })}
  />
);

/**
 * Same renderers at the default (roomier) density — used inside the expanded
 * cell viewer, where there's space to read a full description comfortably.
 */
export const renderCompareValueFull: CompareValueRenderer = (key, value, status) => (
  <EnrichedFieldCell
    testId={`compare-value-full-${key}`}
    fieldName={key}
    value={value}
    {...(status !== undefined && { status })}
  />
);

/**
 * `productHighlight` / `productDetail` render as individually tinted card rows,
 * so the compare cell must not add its own background on top — mirrors the
 * `DiffCell` bypass every table variant already applies to these two fields.
 */
export const isSelfTintedField = (key: string): boolean =>
  key === 'productHighlight' || key === 'productDetail';
